import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { Suspense, lazy } from "react";
import "./App.css";
import Loading from "./utils/Loading";

// Lazy imports
const Login = lazy(() => import("./admin/pages/Login"));
const Dashboard = lazy(() => import("./admin/pages/Dashboard"));
const BannerManagement = lazy(() => import("./admin/pages/BannerManagement"));
const MenuSettings = lazy(() => import("./admin/pages/MenuSettings"));
const Size = lazy(() => import("./admin/pages/Size"));
const Colors = lazy(() => import("./admin/pages/Colors"));
const Products = lazy(() => import("./admin/pages/Products"));
const Contact = lazy(() => import("./admin/pages/Contact"));
const Users = lazy(() => import("./admin/pages/Users"));
const Settings = lazy(() => import("./admin/pages/Settings"));
const Social = lazy(() => import("./admin/pages/Social"));

const Menu = lazy(() => import("./Menu"));
const ProductInfo = lazy(() => import("./ProductInfo"));
const ContactUs = lazy(() => import("./ContactUs"));

const ProtectedRoute = lazy(() => import("./components/ProtectedRoute"));
const PublicRoute = lazy(() => import("./components/PublicRoute"));

function App() {
  return (
    <Router>
    <Suspense fallback={<Loading />}>
        <Routes>

          {/* Public Routes */}
          <Route path="/menu/:restaurant_name" element={<Menu />} />
          <Route path="/product-info/:restaurant_name/:productId" element={<ProductInfo />} />
          <Route path="/contact-us/:restaurant_name" element={<ContactUs />} />

          {/* PublicRoute Wrapper */}
          <Route element={<PublicRoute />}>
            <Route path="/login" element={<Login />} />
          </Route>

          {/* Protected Admin Routes */}
          <Route element={<ProtectedRoute />}>
          <Route path="/test" element={<h1 style={{padding:20}}>Test Works</h1>} />

            <Route path="/admin/dashboard" element={<Dashboard />} />
            <Route path="/admin/banner-management" element={<BannerManagement />} />
            <Route path="/admin/menu-departments" element={<MenuSettings />} />
            <Route path="/admin/sizes-measurement" element={<Size />} />
            <Route path="/admin/colors" element={<Colors />} />
            <Route path="/admin/products" element={<Products />} />
            <Route path="/admin/contact" element={<Contact />} />
            <Route path="/admin/users" element={<Users />} />
            <Route path="/admin/menu-settings" element={<Settings />} />
            <Route path="/admin/social" element={<Social />} />
          </Route>

        </Routes>
      </Suspense>
    </Router>
  );
}

export default App;
